export default __webpack_public_path__ + "static/media/bet2000_receipt.f2289ddd.jpg";